var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"app-page__block car-list",class:{
    'car-list--empty': !_vm.carList.length
  }},[(_vm.carList.length)?_c('div',{staticClass:"car-list__wrapper"},[_vm._l((_vm.carList),function(item){return [_c('CarListCard',{key:item.carId,attrs:{"car":item}})]})],2):_c('CarListEmpty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }